import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import cx from 'classnames';
import { COLOR_MAP, FONT_WEIGHT_MAP, TEXT_ALIGNMENT, TYPE, TYPE_MAPPING } from './constants';
import { defaultProps, fontWeightProp, defaultTypesProp } from './types';
import PropTypes from 'prop-types';

const Typography = props => {
  const {
    align,
    ariaLabel,
    children,
    className: customClassName,
    color,
    component,
    display,
    gutterBottom,
    gutterTop,
    italic,
    noWrap,
    style: styleProp,
    text,
    type,
    weight,
    ...other
  } = props;
  const Component = component || TYPE_MAPPING[type] || 'span';
  const content = children ? children : text;
  const classes = cx(`om-type__${type}`, {
    'om-type--ITALIC': italic,
    'om-type--NO-WRAP': noWrap,
    [`om-margin--BOTTOM--${gutterBottom}`]: gutterBottom,
    [`om-margin--TOP--${gutterTop}`]: gutterTop,
    [FONT_WEIGHT_MAP[weight]]: weight,
    [COLOR_MAP[color]]: color,
    [customClassName]: !!customClassName
  });
  const style = {
    display,
    textAlign: TEXT_ALIGNMENT[align],
    ...styleProp
  };
  return /*#__PURE__*/React.createElement(Component, _extends({
    "aria-label": ariaLabel,
    className: classes,
    style: style
  }, other), content);
};

Typography.defaultProps = {
  italic: false,
  noWrap: false,
  text: '',
  type: TYPE.b1
};
Typography.propTypes = { ...defaultProps,
  ...fontWeightProp,
  ...defaultTypesProp,
  style: PropTypes.object
};
export default Typography;